import styles from "./Login.module.scss";
import bionet_logo from "../../assets/images/bionet-logo/bionet.png";
import { useState } from "react";
import eye from "../../assets/images/login/password/eye.svg";
import closed_eye from "../../assets/images/login/password/closed_eye.svg";
import { adminLogin } from "../../services/auth.service";
import { setCookie } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import MainButton from "../../components/shared/MainButton/MainButton";
import { LoadingOutlined } from "@ant-design/icons";

const Login = () => {
  const [labelEmail, setLabelEmail] = useState("email");
  const [labelPassword, setLabelPassword] = useState("password");
  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    const payload = {
      email: emailValue,
      password: passwordValue,
    };

    try {
      const response = await adminLogin(payload);
      localStorage.setItem("bsc-admin-name", response?.data?.name);
      const token = response?.data?.token;
      const message = response?.data?.message;
      if (response.status === 200 && token) {
        setCookie("BscAdminToken", token, 14);
        setErrMessage("");
        navigate("/admin");
      }
      if (!token) {
        navigate("/login");
        setErrMessage(message);
      }
    } catch (error: any) {
      const message = error?.message;
      setErrMessage(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div id={styles.login_page}>
      <Helmet>
        <title>1412 | Login</title>
      </Helmet>
      <div className={styles.login_page}>
        <div className={styles.login_secton_left}>
          <div className={styles.logo}>
            <img src={bionet_logo} alt="bionet" />
          </div>
          <div className={styles.content}>
            <div>
              <h1 className={styles.login_title}>
                1412 admin panelinə xoş gəlmisiniz.
              </h1>
              <p className={styles.login_subtitle}>
                Davam etmək üçün daxil olun
              </p>
            </div>
          </div>
        </div>
        <div className={styles.login_secton_right}>
          <div className={styles.form_section}>
            <div className={styles.form_logo}>
              <img src={bionet_logo} alt="bionet" />
            </div>
            <h1 className={styles.form_title}>Daxil olun</h1>
            {errMessage ? (
              <p className={styles.err_msg}>
                <i className="fa-solid fa-x"></i> {errMessage}
              </p>
            ) : (
              ""
            )}

            <form
              className={styles.form}
              action=""
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <div className={styles.form_input}>
                <label
                  className={`${styles.label} ${
                    emailValue === "" && labelEmail === "email"
                      ? styles.label_act
                      : ""
                  }`}
                  htmlFor="email"
                >
                  E-poçtunuz
                </label>
                <div className={styles.input_wrapper}>
                  <input
                    autoComplete="off"
                    onFocus={() => setLabelEmail("")}
                    onBlur={() =>
                      setLabelEmail(emailValue === "" ? "email" : "")
                    }
                    onChange={(e) => setEmailValue(e.target.value)}
                    value={emailValue}
                    type="email"
                    name="email"
                    id="email"
                    placeholder={
                      labelEmail === "email" ? "" : "example@gmail.com"
                    }
                  />
                  <span className={styles.focus_border}></span>
                </div>
              </div>

              <div className={styles.form_input}>
                <label
                  className={`${styles.label} ${
                    passwordValue === "" && labelPassword === "password"
                      ? styles.label_act
                      : ""
                  }`}
                  htmlFor="password"
                >
                  Parolunuz
                </label>
                <div className={styles.input_wrapper}>
                  <input
                    autoComplete="new-password"
                    onFocus={() => setLabelPassword("")}
                    onBlur={() =>
                      setLabelPassword(passwordValue === "" ? "password" : "")
                    }
                    onChange={(e) => setPasswordValue(e.target.value)}
                    value={passwordValue}
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder={
                      labelPassword === "password" ? "" : "••••••••••"
                    }
                  />
                  <span className={styles.focus_border}></span>

                  {isPasswordVisible ? (
                    <img
                      onClick={togglePasswordVisibility}
                      className={styles.eye_icon}
                      src={closed_eye}
                      alt=""
                    />
                  ) : (
                    <img
                      onClick={togglePasswordVisibility}
                      className={styles.eye_icon}
                      src={eye}
                      alt=""
                    />
                  )}
                </div>
              </div>
              <MainButton
                full
                disabled={
                  isLoading || emailValue === "" || passwordValue === ""
                }
                type="submit"
              >
                {isLoading ? (
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "#fff" }}
                    spin
                  />
                ) : (
                  "DAVAM EDİN"
                )}
              </MainButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
